import React, { memo } from "react";
import AerosNode from "./AerosNode";

export default memo(({ data, id, isConnectable, selected }) => (
  <AerosNode id={id} type="ticket" selected={selected} isConnectable={isConnectable}>
    {data.queue?.name}
  </AerosNode>
));
